import { ApolloClient } from "@apollo/client";
import {
  AccountingRemittance,
  AccountingRemittanceProps,
} from "@/core/entities/accounting";
import {
  IAccountingRemittanceRepository,
  IGetAccountingRemittancesRepositoryParams,
  IGetAccountingRemittancesRepositoryResponse,
} from "@/core/repositories/accounting/IAccountingRemittance.repository";
import { IDeductionColumns } from "@/core/repositories/deduction/IDeduction.repository";
import GET_ACCOUNTING_REMITTANCES from "@/core/graphql/accounting/getAccountingRemittances";

interface IGetAccountingRemittancesQueryResponse {
  getAccountingRemittances: {
    total: number;
    page: number;
    limit: number;
    columns: IDeductionColumns[];
    innerColumns: IDeductionColumns[];
    items: AccountingRemittanceProps[];
  };
}

export class AccountingRemittanceRepository implements IAccountingRemittanceRepository {
  constructor(private readonly client: ApolloClient) {}

  public async getAccountingRemittances(
    params: IGetAccountingRemittancesRepositoryParams,
    refetch: boolean = false
  ): Promise<IGetAccountingRemittancesRepositoryResponse> {
    const { data } = await this.client.query<IGetAccountingRemittancesQueryResponse>({
      query: GET_ACCOUNTING_REMITTANCES,
      variables: { params },
      fetchPolicy: refetch ? "network-only" : "cache-first",
    });

    if (!data) {
      throw new Error("Failed to get accounting remittances");
    }

    return {
      getAccountingRemittances: data.getAccountingRemittances.items.map(item =>
        AccountingRemittance.fromJson(item)
      ),
      totalCount: data.getAccountingRemittances.total,
      currentPage: data.getAccountingRemittances.page,
      pageLimit: data.getAccountingRemittances.limit,
      columns: data.getAccountingRemittances.columns,
      innerColumns: data.getAccountingRemittances.innerColumns,
    };
  }
}
